import createIcon from '../../createIcon';

/**
 * @component @name GpsOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuOTQgMTFDMjAuNDggNi44MyAxNy4xNyAzLjUyIDEzIDMuMDZWMUgxMVYzLjA2QzkuODcgMy4xOCA4LjgxIDMuNTIgNy44NCA0LjAzTDkuMzQgNS41M0MxMC4xNiA1LjE5IDExLjA2IDUgMTIgNUMxNS44NyA1IDE5IDguMTMgMTkgMTJDMTkgMTIuOTQgMTguODEgMTMuODQgMTguNDggMTQuNjVMMTkuOTggMTYuMTVDMjAuNDggMTUuMTkgMjAuODIgMTQuMTMgMjAuOTUgMTNIMjNWMTFIMjAuOTRaTTMgNC4yN0w1LjA0IDYuMzFDMy45NyA3LjYyIDMuMjUgOS4yMyAzLjA2IDExSDFWMTNIMy4wNkMzLjUyIDE3LjE3IDYuODMgMjAuNDggMTEgMjAuOTRWMjNIMTNWMjAuOTRDMTQuNzcgMjAuNzQgMTYuMzggMjAuMDMgMTcuNjkgMTguOTZMMTkuNzMgMjFMMjEgMTkuNzNMNC4yNyAzTDMgNC4yN1pNMTYuMjcgMTcuNTRDMTUuMDkgMTguNDUgMTMuNjEgMTkgMTIgMTlDOC4xMyAxOSA1IDE1Ljg3IDUgMTJDNSAxMC4zOSA1LjU1IDguOTEgNi40NiA3LjczTDE2LjI3IDE3LjU0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GpsOff = createIcon('GpsOff', [
  [
    'path',
    {
      d: 'M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C9.87 3.18 8.81 3.52 7.84 4.03L9.34 5.53C10.16 5.19 11.06 5 12 5C15.87 5 19 8.13 19 12C19 12.94 18.81 13.84 18.48 14.65L19.98 16.15C20.48 15.19 20.82 14.13 20.95 13H23V11H20.94ZM3 4.27L5.04 6.31C3.97 7.62 3.25 9.23 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C14.77 20.74 16.38 20.03 17.69 18.96L19.73 21L21 19.73L4.27 3L3 4.27ZM16.27 17.54C15.09 18.45 13.61 19 12 19C8.13 19 5 15.87 5 12C5 10.39 5.55 8.91 6.46 7.73L16.27 17.54Z',
      key: '1awmjb',
    },
  ],
]);

export default GpsOff;
